import { UserManager, WebStorageStateStore, User as OidcUser } from 'oidc-client-ts';

const KC_URL = import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8090';
const KC_REALM = import.meta.env.VITE_KEYCLOAK_REALM || 'netra';
const KC_CLIENT = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'netra-frontend';

export const oidcManager = new UserManager({
  authority: `${KC_URL}/realms/${KC_REALM}`,
  client_id: KC_CLIENT,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}/login`,
  response_type: 'code',
  scope: 'openid profile email',
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  monitorSession: false,
});

export async function ssoLogin(): Promise<void> {
  await oidcManager.signinRedirect();
}

export async function ssoHandleCallback(): Promise<OidcUser | null> {
  try {
    return await oidcManager.signinRedirectCallback();
  } catch (e) {
    console.error('OIDC callback failed', e);
    return null;
  }
}

export async function ssoLogout(): Promise<void> {
  try {
    await oidcManager.signoutRedirect();
  } catch {
    await oidcManager.removeUser();
    window.location.href = '/login';
  }
}

export async function ssoGetUser(): Promise<OidcUser | null> {
  return oidcManager.getUser();
}

export async function ssoGetAccessToken(): Promise<string | null> {
  const u = await oidcManager.getUser();
  if (!u || u.expired) return null;
  return u.access_token;
}
